{
  "error": "错误",
  "help": "帮助",
  "info": "信息",
  "success": "成功",
  "warning": "警告"
}
